import Phaser from 'phaser';
import { ITeamDrawingSizes, ITeamModes, iteamColorModelInstance, iteamWorkingModeInstance } from '../datamodel/datamodel';


class PageSceneBase extends Phaser.Scene {

    constructor(param) {
        super(param.key);
        this.config = param.config;

        this.closeDrawingThicknessMenuCallback = () => {};

        this.resizeHandler = param.resizeHandler;
        this.pageImage = null;
        this.origDragPoint = null;
        this.contentContainer = null;
        this.PAGE_ZOOM_ANIM_DURATION = 100;
        this.gameInputTextDiv = null;
        this.lastZoomBehavior = 'zoomFitWidth';

        this.startDrawingX = 0;
        this.startDrawingY = 0;

        this.renderTexturePen = null;
        this.renderTextureMarker = null;

        this.graphicsBrush = null;

        this.prepareDrawingBrush = this.prepareDrawingBrush.bind(this);

    }

    preload() {
        console.log('PageSceneBase preload');
    }

    create() {
        this.contentContainer = this.add.container(0, 0);
        this.cameras.main.setBackgroundColor('#E6E6E5');
        this.gameInputTextDiv = document.getElementById('gameInputTextDiv');

        this.input.on('pointerdown', (pointer) => {
            if (iteamWorkingModeInstance.getMode() !== ITeamModes.pen && iteamWorkingModeInstance.getMode() !== ITeamModes.marker && iteamWorkingModeInstance.getMode() !== ITeamModes.eraser) {
                return;
            }

            // close drawing thickness selection menu immediately
            if (this.closeDrawingThicknessMenuCallback !== undefined && this.closeDrawingThicknessMenuCallback !== null) {
                this.closeDrawingThicknessMenuCallback();
            }

            if (this.renderTextureMarker === null || this.renderTexturePen === null) {
                return;
            }

    
            this.startDrawingX = (pointer.x) / this.contentContainer.scale;
            this.startDrawingY = (pointer.y) / this.contentContainer.scale;
            this.drawOnRenderTextures(this.startDrawingX, this.startDrawingY);
        }, this);

        this.input.on('pointermove', (pointer) => {
            this.followPointerAndDoCalculations(pointer);
        }, this);

        iteamWorkingModeInstance.setChangeModeOrSizeCallBack(this.prepareDrawingBrush);
        iteamColorModelInstance.setChangeColorCallBack(this.prepareDrawingBrush);
    }


    update() {

        if (this.contentContainer !== null && this.pageImage !== null && iteamWorkingModeInstance.getMode() === ITeamModes.interaction) {
            this.scrollPage();
        }

    }

    addDrawingCanvases() {
        if (this.renderTexturePen !== null) {
            this.renderTexturePen.destroy();
            this.renderTexturePen = null;
        }

        if (this.renderTextureMarker !== null) {
            this.renderTextureMarker.destroy();
            this.renderTextureMarker = null;
        }

        if (this.pageImage === null) {
            return;
        }

        this.renderTexturePen = this.add.renderTexture(0, 0, this.pageImage.width, this.pageImage.height).setOrigin(0);
        this.renderTextureMarker = this.add.renderTexture(0, 0, this.pageImage.width, this.pageImage.height).setOrigin(0);

        this.contentContainer.add(this.renderTextureMarker);
//        this.renderTextureMarker.blendMode = Phaser.BlendModes.MULTIPLY; // does not work under CANVAS type
        this.renderTextureMarker.alpha = 0.55;
        this.contentContainer.add(this.renderTexturePen);
    }

    setWorkingMode(mode) {
        iteamWorkingModeInstance.setMode(mode);
    }


    prepareDrawingBrush(type) {

        console.log('DRAWING BRUSH IS READY FOR DRAWING');

        this.graphicsBrush = new Phaser.GameObjects.Graphics(this);

        if (iteamWorkingModeInstance.getMode() === ITeamModes.pen) {
            if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.pen) === ITeamDrawingSizes.small) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(2, 2, 2);    
            } else if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.pen) === ITeamDrawingSizes.medium) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(3, 3, 3);    
            } else if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.pen) === ITeamDrawingSizes.large) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(5, 5, 5);    
            }
        } else if (iteamWorkingModeInstance.getMode() === ITeamModes.marker) {
            if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.marker) === ITeamDrawingSizes.small) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(6, 6, 6);    
            } else if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.marker) === ITeamDrawingSizes.medium) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(9, 9, 9);    
            } else if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.marker) === ITeamDrawingSizes.large) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(12, 12, 12);    
            }            
        } else if (iteamWorkingModeInstance.getMode() === ITeamModes.eraser) {
            if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser) === ITeamDrawingSizes.small) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(12, 12, 12);    
            } else if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser) === ITeamDrawingSizes.medium) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(16, 16, 16);    
            } else if (iteamWorkingModeInstance.getDrawingSizeOfMode(ITeamModes.eraser) === ITeamDrawingSizes.large) {
                this.graphicsBrush.fillStyle(iteamColorModelInstance.getColor().colorcode, 1);
                this.graphicsBrush.fillCircle(18, 18, 18);    
            }            
        }

        if (type !== undefined && type === 'eraseall') {
            this.renderTextureMarker.clear();
            this.renderTexturePen.clear();
        }
        
    }

    drawOnRenderTextures(x, y) {
        let newX = Math.round(x) - this.contentContainer.x / this.contentContainer.scale;
        let newY = Math.round(y) - this.contentContainer.y / this.contentContainer.scale;
        if (iteamWorkingModeInstance.getMode() === ITeamModes.pen) {
            this.renderTexturePen.draw(this.graphicsBrush, newX, newY, 1);
        } else if (iteamWorkingModeInstance.getMode() === ITeamModes.marker) {
            this.renderTextureMarker.draw(this.graphicsBrush, newX, newY, 1);
        } else if (iteamWorkingModeInstance.getMode() === ITeamModes.eraser) {
            this.renderTexturePen.erase(this.graphicsBrush, newX, newY);
            this.renderTextureMarker.erase(this.graphicsBrush, newX, newY);
        }
    }

    followPointerAndDoCalculations(pointer) {

        if (iteamWorkingModeInstance.getMode() !== ITeamModes.pen && iteamWorkingModeInstance.getMode() !== ITeamModes.marker && iteamWorkingModeInstance.getMode() !== ITeamModes.eraser) {
            return;
        }


        if (this.renderTextureMarker === null || this.renderTexturePen === null) {
            return;
        }


        if (!pointer.isDown) {
            return;
        }


        let x = (pointer.x) / this.contentContainer.scale;
        let y = (pointer.y) / this.contentContainer.scale;

        let padX = this.startDrawingX;
        let padY = this.startDrawingY;

        let dx = Math.abs(x - padX);
        let dy = Math.abs(y - padY);

        let incline = 0;

        if (dx > 0 && dy > 0 && dx > dy) {
            incline = dy / dx;
        } else if (dx > 0 && dy > 0 && dx < dy) {
            incline = dx / dy;
        } 


        if (dx > dy) { // loop through x, it is longer
            if (padX < x) {
                for (let i = Math.round(padX); i <= Math.round(x); i++) {
                    if (padY < y) {
                        padY += incline;
                    } else if (padY > y) {
                        padY -= incline;
                    }
                    this.drawOnRenderTextures(i, padY);
                }
            } else if (padX > x) {
                for (let i = Math.round(padX); i >= Math.round(x); i--) {
                    if (padY < y) {
                        padY += incline;
                    } else if (padY > y) {
                        padY -= incline;
                    }
                    this.drawOnRenderTextures(i, padY);
                }
            }
        } else if (dx < dy) { // loop through y, it is longer
            if (padY < y) {
                for (let i = Math.round(padY); i <= Math.round(y); i++) {
                    if (padX < x) {
                        padX += incline;
                    } else if (padX > x) {
                        padX -= incline;
                    }
                    this.drawOnRenderTextures(padX, i);
                }
            } else if (padY > y) {
                for (let i = Math.round(padY); i >= Math.round(y); i--) {
                    if (padX < x) {
                        padX += incline;
                    } else if (padX > x) {
                        padX -= incline;
                    }
                    this.drawOnRenderTextures(padX, i);
                }
            }
        }

        this.drawOnRenderTextures(x, y);

        this.startDrawingX = x;
        this.startDrawingY = y;

    }

    zoomInByTenPercent() {
        if (this.pageImage === null) {
            return;
        }

        if (this.gameInputTextDiv !== null && this.gameInputTextDiv !== undefined) {
            this.gameInputTextDiv.style.visibility = 'hidden';
        }

        let currentZoomValue = this.contentContainer.scale;
        let newZoomValue = currentZoomValue;

        if (currentZoomValue < 2) { // allow to zoom in if the scale factor is below 2
            newZoomValue = currentZoomValue / 0.9;
        }

        this.contentContainer.scale = newZoomValue;
        if (this.pageImage.width * this.contentContainer.scale < this.config.width) {
            // image scaled width is shorter than scene width, center it.
            this.centerContentX(this.contentContainer.scale);
        }

        if (this.pageImage.height * this.contentContainer.scale < this.config.height) {
            // image scaled height is shorter than scene height, center it.
            this.centerContentY(this.contentContainer.scale);
        }

        this.lastZoomBehavior = 'zoomInByTenPercent';
    }

    zoomOutByTenPercent() {
        if (this.pageImage === null) {
            return;
        }

        if (this.gameInputTextDiv !== null && this.gameInputTextDiv !== undefined) {
            this.gameInputTextDiv.style.visibility = 'hidden';
        }

        let currentZoomValue = this.contentContainer.scale;
        let newZoomValue = currentZoomValue;
        if (currentZoomValue > 0.1) {
            newZoomValue = 0.9 * currentZoomValue;
        }

        // let tmpZoomValue = newZoomValue;

        // if (this.pageImage.width * newZoomValue > this.config.width / 2) {
        //     tmpZoomValue = this.config.width / this.pageImage.width;
        // }

        // if (this.pageImage.height * newZoomValue > this.config.height / 2) {
        //     tmpZoomValue = this.config.height / this.pageImage.height;
        // }
        
        // if (tmpZoomValue < newZoomValue) {
        //     newZoomValue = tmpZoomValue;
        // }

        this.contentContainer.scale = newZoomValue;
        
        if (this.pageImage.width * this.contentContainer.scale < this.config.width) {
            // image scaled width is shorter than scene width, center it.
            this.centerContentX(this.contentContainer.scale);
        }

        if (this.pageImage.height * this.contentContainer.scale < this.config.height) {
            // image scaled height is shorter than scene height, center it.
            this.centerContentY(this.contentContainer.scale);
        }

        this.lastZoomBehavior = 'zoomOutByTenPercent';
    }


    zoomFitWidth() {
        if (this.pageImage === null) {
            return;
        }

        if (this.gameInputTextDiv !== null && this.gameInputTextDiv !== undefined) {
            this.gameInputTextDiv.style.visibility = 'hidden';
        }

        let newZoomValue = this.config.width / this.pageImage.width;
        this.contentContainer.scale = newZoomValue;

        this.centerContent(newZoomValue);
        this.lastZoomBehavior = 'zoomFitWidth';
    }

    zoomFitHeight() {
        if (this.pageImage === null) {
            return;
        }

        if (this.gameInputTextDiv !== null && this.gameInputTextDiv !== undefined) {
            this.gameInputTextDiv.style.visibility = 'hidden';
        }

        let newZoomValue = this.config.height / this.pageImage.height;
        this.contentContainer.scale = newZoomValue;

        this.centerContent(newZoomValue);
        this.lastZoomBehavior = 'zoomFitHeight';
    }

    zoomRecalculate() {
        if (this.lastZoomBehavior === 'zoomFitWidth') {
            this.zoomFitWidth();
        } else if (this.lastZoomBehavior === 'zoomFitHeight') {
            this.zoomFitHeight();
        }
    }

    centerContent(newZoomValue) {
        this.centerContentY(newZoomValue);
        this.centerContentX(newZoomValue);
    }

    centerContentX(newZoomValue) {

        let halfWidthDiffSize = ((this.pageImage.width * newZoomValue) - this.config.width) / 2;
        this.contentContainer.x = -halfWidthDiffSize;
        
    }

    centerContentY(newZoomValue) {

        let halfHeightDiffSize = ((this.pageImage.height * newZoomValue) - this.config.height) / 2;
        this.contentContainer.y = -halfHeightDiffSize;
    }

    scrollPage() {
        if (this.input.activePointer.isDown) { 


            if (this.origDragPoint) {


                let newX = this.contentContainer.x - (this.origDragPoint.x - this.input.activePointer.position.x);
                let newY = this.contentContainer.y - (this.origDragPoint.y - this.input.activePointer.position.y);
                
                /*
                if (this.snapToEdgesAfterScroll(newX, newY) === false) {
                    // if there is no need to snap to edges then set the new coordinates
                    this.contentContainer.x = newX;
                    this.contentContainer.y = newY;    
                }
                */
                


                this.contentContainer.x = newX;
                this.contentContainer.y = newY;  
                this.snapToEdgesAfterScroll(newX, newY);
            }
            this.origDragPoint = this.input.activePointer.position.clone();
        } else {
            this.origDragPoint = null;
        }
    }

    snapToEdgesAfterScroll(newX, newY) {
        let xyCoordinatesModified = false;
        if (newY > 0) {
            if (this.pageImage.height * this.contentContainer.scale > this.config.height) {
                this.contentContainer.y = 0;
                xyCoordinatesModified = true;
            } else {
                this.centerContentY(this.contentContainer.scale);
            }
        } else if (newY < -(this.pageImage.height * this.contentContainer.scale - this.config.height)) {
            this.contentContainer.y = -(this.pageImage.height * this.contentContainer.scale - this.config.height);
            xyCoordinatesModified = true;
        }


        if (newX > 0) {
            if (this.pageImage.width * this.contentContainer.scale > this.config.width) {
                this.contentContainer.x = 0;
                xyCoordinatesModified = true;
            } else {
                this.centerContentX(this.contentContainer.scale);
            }
        } else if (newX < -(this.pageImage.width * this.contentContainer.scale - this.config.width)) {
            this.contentContainer.x = -(this.pageImage.width * this.contentContainer.scale - this.config.width);
            xyCoordinatesModified = true;
        }

        return xyCoordinatesModified;
    }


}

export default PageSceneBase;